module.exports = __webpack_public_path__ + "img/nav1-active.e543acb4.png";